module.exports = "../../static/img/logo.3d4a310.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.png
// module id = 1330
// module chunks = 0